import type { JsonDataItem } from '@myosh/odin-components';
import { useEffect, useState } from 'react';
import useFetchWorkflowSteps from './use-workflow-steps';

const useModuleWorkflowSteps = (formId?: number) => {
  const [steps, setSteps] = useState<Array<JsonDataItem>>();

  const { workflowSteps, isFetchingWorkflowSteps } = useFetchWorkflowSteps(formId ?? 0);

  useEffect(() => {
    if (!isFetchingWorkflowSteps) {
      setSteps(
        workflowSteps
          ?.filter((step) => !step.draft)
          .map((step) => {
            return { text: step.label, value: step.id, originalData: step };
          })
      );
    }
  }, [workflowSteps, isFetchingWorkflowSteps]);

  return steps;
};

export default useModuleWorkflowSteps;
